import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() block: boolean = false;
  @Input() buttonType: string = 'primary';
  @Input() classes: string = '';
  @Input() disabled: boolean = false;
  @Input() small: boolean = false;
  @Input() style: string = '';
  @Input() type: string = 'button';

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent() {
    this.onClick.emit();
  }
}
